"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackError = exports.trackAction = exports.identify = exports.setupAnalytics = void 0;
var Sentry = __importStar(require("@sentry/react"));
var SentryBrowser = __importStar(require("@sentry/browser"));
var amplitude = __importStar(require("@amplitude/analytics-browser"));
var PROD_ENVIRONMENT = "prd-prd";
/**
 * Initialize Sentry and Amplitude
 * @param {Object} [amplitudeConfig]
 * @param {string} amplitudeConfig.apiKey - Amplitude API Key
 * @param {Object} [amplitudeConfig.config] - Amplitude configuration - Refer to https://www.docs.developers.amplitude.com/data/sdks/browser-2/#configuration
 * @param {string} [amplitudeConfig.config.defaultTracking.attribution=false]
 * @param {string} [amplitudeConfig.config.defaultTracking.sessions=false]
 * @param {string} [amplitudeConfig.config.defaultTracking.formInteractions=false]
 * @param {string} [amplitudeConfig.config.defaultTracking.fileDownloads=false]
 * @param {Object} [sentryConfig] - Refer to https://docs.sentry.io/platforms/javascript/configuration/
 */
function setupAnalytics(_a) {
    var _b;
    var user = _a.user, deploymentEnv = _a.deploymentEnv, releaseVersion = _a.releaseVersion, amplitudeConfig = _a.amplitudeConfig, sentryConfig = _a.sentryConfig;
    if (amplitudeConfig) {
        var DEFAULT_SERVER_ZONE = "EU";
        var apiKey = amplitudeConfig.apiKey, options = amplitudeConfig.options;
        if (apiKey.length === 0)
            console.error("amplitude SDK - Invalid API Key! Amplitude integration will not work.");
        var defaultOptions = {
            serverZone: DEFAULT_SERVER_ZONE,
            defaultTracking: {
                attribution: false,
                sessions: false,
                formInteractions: false,
                fileDownloads: false,
            },
        };
        if (typeof options !== "undefined" && !options.defaultTracking)
            options.defaultTracking = defaultOptions.defaultTracking;
        amplitude.init(apiKey, typeof options !== "undefined"
            ? __assign({ serverZone: DEFAULT_SERVER_ZONE }, options) : defaultOptions);
    }
    if (sentryConfig) {
        var _c = sentryConfig.sampleRate, sampleRate = _c === void 0 ? 0.1 : _c, _d = sentryConfig.tracesSampleRate, tracesSampleRate = _d === void 0 ? 0.1 : _d, _e = sentryConfig.integrations, integrations = _e === void 0 ? [] : _e, rest = __rest(sentryConfig, ["sampleRate", "tracesSampleRate", "integrations"]);
        if (isNaN(Number((_b = sentryConfig.dsn) === null || _b === void 0 ? void 0 : _b.length)))
            console.error("sentry SDK - Invalid DSN! Sentry integration will not work.");
        var defaultIntegrations = [
            SentryBrowser.browserTracingIntegration(),
        ];
        if (deploymentEnv === PROD_ENVIRONMENT)
            defaultIntegrations.push(Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
            }));
        Sentry.init(__assign(__assign(__assign({ release: releaseVersion, environment: deploymentEnv }, (integrations.length === 0
            ? {
                integrations: defaultIntegrations,
            }
            : { integrations: integrations })), { sampleRate: sampleRate, tracesSampleRate: tracesSampleRate }), rest));
    }
    if (user) {
        (0, exports.identify)(user);
    }
}
exports.setupAnalytics = setupAnalytics;
/**
 * Function to set user properties to a particular user.
 * User properties are details like device details, user preferences, or language to help you understand
 * your users at the time they performed an action in your application.
 * This sets the properties on amplitude and Sentry.
 * @param user
 */
var identify = function (user) {
    // sentry
    Sentry.setContext(user.id, user);
    // amplitude
    var identifyEvent = new amplitude.Identify();
    identifyEvent.set("id", user.id);
    Object.keys(user)
        .filter(function (key) { return key !== "id" && typeof key !== "undefined"; })
        .forEach(function (key) { return identifyEvent.set(key, user[key]); });
    amplitude.identify(identifyEvent);
};
exports.identify = identify;
/**
 * Function to record an action on analytics platform.
 * @param action this is the name of the event
 * @param actionParams this is additional data to provide context for this event
 */
var trackAction = function (action, actionParams) {
    amplitude.track(action, actionParams);
};
exports.trackAction = trackAction;
/**
 * Function to track an error on Sentry
 * @param error Error object or error message
 * @param errorParams Custom data associated with the error
 * @param isMessage Use Sentry.captureMessage method
 */
var trackError = function (error, errorParams, isMessage) {
    Sentry.withScope(function (scope) {
        errorParams && scope.setExtras(errorParams);
        if (isMessage && typeof error === "string") {
            Sentry.captureMessage(error, "error");
        }
        else {
            Sentry.captureException(error instanceof Error ? error : new Error(error));
        }
    });
};
exports.trackError = trackError;
__exportStar(require("./ErrorBoundary"), exports);
__exportStar(require("./SentryDebugger"), exports);
